"use strict";
exports.__esModule = true;
var Comparison_1 = require("./Comparison");
var SeqHelpers_1 = require("./SeqHelpers");
var preludeTsContractViolationCb = function (msg) { throw msg; };
/**
 * Some programmatic errors are only detectable at runtime
 * (for instance trying to setup a <code>HashSet</code> of <code>Option&lt;number[]&gt;</code>: you
 * can't reliably compare a <code>number[]</code> therefore you can't compare
 * an <code>Option&lt;number[]&gt;</code>.. but we can't detect this error at compile-time
 * in typescript). So when we detect them at runtime, prelude-ts throws
 * an exception by default.
 * This function allows you to change that default action
 * (for instance, you could display an error message in the console,
 * or log the error)
 *
 * You can reproduce the issue easily by running for instance:
 *
 *  HashSet.of(Option.of([1]))
 *  => throws
 */
function setContractViolationAction(action) {
    preludeTsContractViolationCb = action;
}
exports.setContractViolationAction = setContractViolationAction;
/**
 * @hidden
 */
function reportContractViolation(msg) {
    preludeTsContractViolationCb(msg);
}
exports.reportContractViolation = reportContractViolation;
/**
 * @hidden
 */
function contractTrueEquality(context) {
    var vals = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        vals[_i - 1] = arguments[_i];
    }
    for (var _a = 0, vals_1 = vals; _a < vals_1.length; _a++) {
        var val = vals_1[_a];
        if (val) {
            if (val.hasTrueEquality && (!val.hasTrueEquality())) {
                reportContractViolation(context + ": element doesn't support true equality: " + SeqHelpers_1.toStringHelper(val));
            }
            if (!Comparison_1.hasTrueEquality(val).getOrThrow()) {
                reportContractViolation(context + ": element doesn't support equality: " + SeqHelpers_1.toStringHelper(val));
            }
            // the first element i find is looking good, aborting
            return;
        }
    }
}
exports.contractTrueEquality = contractTrueEquality;
//# sourceMappingURL=Contract.js.map